import React from 'react';
import { printDE_Date } from '../../../../../../mol_function';

import './index.scss';

interface AvailabilityProps {
  cutOff: any;
  productsDeliveryTime: number;
  productsDeliveryDate: Date | undefined;
  productsDeliveryTimeOverride: number | undefined;
  domainPrefix: string;
}
export function getTextStatic(
  pdl: number,
  date: Date | undefined,
  productsDeliveryTimeOverride: number | undefined,
) {
  //debugger;
  pdl = +pdl;
  if (pdl === 0 || pdl === 996)
    return (
      <React.Fragment>
        <strong>auf Lager</strong>, Lieferzeit 1-2 Werktage
      </React.Fragment>
    );
  else if (pdl > 0 && pdl <= 30) {
    let timeFrame = pdl + 1 + '-' + (pdl + 2);
    if (pdl > 9) timeFrame = 'ca. ' + (pdl + 1);

    return <React.Fragment>Lieferzeit {timeFrame} Werktage</React.Fragment>;
  } else if (pdl === 84 || pdl === 997)
    return <React.Fragment>wieder verfügbar in ca. 3 Monaten</React.Fragment>;
  else if (pdl === 90)
    return <React.Fragment>Lieferzeit 6-8 Wochen</React.Fragment>;
  else if (pdl === 994) {
    let l1 = 2;

    if (productsDeliveryTimeOverride != undefined) {
      l1 = +productsDeliveryTimeOverride;
    }
    let timeFrame = l1 + '-' + (l1 + 1);
    if (l1 > 9) timeFrame = 'ca. ' + l1;

    return (
      <React.Fragment>
        <b>Dieses Produkt wird für Sie gedruckt</b>, Lieferzeit {timeFrame}{' '}
        Werktage
      </React.Fragment>
    );
  } else if (pdl === 998) {
    let additionalText = '';
    if (date != undefined && date > new Date()) {
      additionalText = '(' + printDE_Date(date) + ')';
    }
    return (
      <React.Fragment>
        <b>Vorbestellbar</b>. Lieferung zum Erscheinungsdatum {additionalText}
      </React.Fragment>
    );
  } else if (pdl === 999 || true)
    // True ist Fallback
    return <React.Fragment>Artikel zur Zeit nicht bestellbar</React.Fragment>;
}
export function getdivClassStatic(pdl: number) {
  pdl = +pdl;
  if (pdl === 0 || pdl === 996) return 'green';
  else if (pdl == 998 || pdl === 994) return 'blue';
  else if (pdl > 0 && pdl <= 30) return 'yellow';
  else return 'red';
}
interface AvailabilityState {
  hInterval: any;
  seconds: number;
}
export default class Availability extends React.Component<
  AvailabilityProps,
  AvailabilityState
> {
  constructor(prop: AvailabilityProps) {
    super(prop);
    this.state = {
      seconds: prop.cutOff,
      hInterval: undefined,
    };
  }
  getText() {
    return getTextStatic(
      this.props.productsDeliveryTime,
      this.props.productsDeliveryDate,
      this.props.productsDeliveryTimeOverride,
    );
  }

  getdivClass() {
    return getdivClassStatic(this.props.productsDeliveryTime);
  }

  componentDidMount() {
    let hInterval = setInterval(() => {
      this.updateCoutDown();
    }, 1000);
    this.setState({ hInterval: hInterval });
  }

  componentWillUnmount() {
    if (this.state.hInterval != undefined) clearInterval(this.state.hInterval);
    this.setState({ hInterval: undefined });
  }

  updateCoutDown() {
    let seconds = this.state.seconds;

    let pad = (n) => (n < 10 ? '0' + n : n);
    var days = Math.floor(seconds / 24 / 60 / 60);
    var hoursLeft = Math.floor(seconds - days * 86400);
    var hours = Math.floor(hoursLeft / 3600);
    var minutesLeft = Math.floor(hoursLeft - hours * 3600);
    var minutes = Math.floor(minutesLeft / 60);
    var remainingSeconds = seconds % 60;
    let text = pad(hours) + ':' + pad(minutes) + ':' + pad(remainingSeconds);
    let htmlElement = undefined;
    if (seconds == 0) {
      clearInterval(this.state.hInterval);
      this.setState({ hInterval: undefined });
      htmlElement = document.getElementById('countdownDiv');
      if (htmlElement != undefined) htmlElement.innerHTML = '';
    } else {
      seconds--;
    }
    htmlElement = document.getElementById('countdownDivTimer');
    if (htmlElement != undefined) htmlElement.innerHTML = text;

    this.setState({ seconds: seconds });
  }

  render() {
    return (
      <React.Fragment>
        <div id="Availability">
          <div className={this.getdivClass()}>
            <div id="verfuegbarkeit">{this.getText()}</div>
          </div>

          {this.props.productsDeliveryTime === 0 && this.props.cutOff > 0 && (
            <div id="countdownDiv">
              <a
                target="_blank"
                rel="noopener"
                href={
                  this.props.domainPrefix + '/index.php?main_page=page&id=124'
                }
              >
                Bestellen Sie innerhalb von <span id="countdownDivTimer"></span>{' '}
                <i className="far fa-clock"></i> und wir versenden dieses
                Produkt noch heute.
              </a>
            </div>
          )}
        </div>
      </React.Fragment>
    );
  }
}
